function cov_20au7ujn6l() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/LocationPinHome.tsx";
  var hash = "5519002f96bb35baf89de909a3eee4a77ed45a47";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/LocationPinHome.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 57
        },
        end: {
          line: 5,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "5519002f96bb35baf89de909a3eee4a77ed45a47"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_20au7ujn6l = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_20au7ujn6l();
var Icon = (cov_20au7ujn6l().s[0]++, {
  name: 'location-pin-home',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 18.5061L16.2426 14.2635C18.5858 11.9203 18.5858 8.12132 16.2426 5.77817C13.8995 3.43503 10.1005 3.43503 7.75736 5.77817C5.41421 8.12132 5.41421 11.9203 7.75736 14.2635L12 18.5061ZM18.0104 4.01041C14.691 0.690949 9.30905 0.690949 5.98959 4.01041C2.67014 7.32986 2.67014 12.7118 5.98959 16.0312L12 22.0416L18.0104 16.0312C21.3299 12.7118 21.3299 7.32986 18.0104 4.01041Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13 10.0514L12 9.35144L11 10.0514V10.7998H13V10.0514ZM15.5 8.93203V12.9498C15.5 13.1431 15.3433 13.2998 15.15 13.2998H8.85C8.6567 13.2998 8.5 13.1431 8.5 12.9498V8.93203C8.5 8.81782 8.55572 8.71079 8.64929 8.6453L11.7993 6.4403C11.9198 6.35594 12.0802 6.35594 12.2007 6.4403L15.3507 8.6453C15.4443 8.71079 15.5 8.81782 15.5 8.93203Z\" fill=\"currentColor\"/>"
});
export default Icon;